// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2j6VF","overflowing":"ReadFullNote_overflowing__1UGL_"};